// extracted by mini-css-extract-plugin
export default {"text":"HintFindWrongPixel_text__TAodF"};